import PersonalizedSampleProductsPage from "../features/admin/personalized-users/products/sample-products-page";
import AddAndEditSampleProductPage from "../features/admin/sample-products/add-and-edit-sample-product-page/add-and-edit-sample-product-page";
import AddAndEditStockProductPage from "../features/admin/stock-products/add-and-edit-stock-product-page/add-and-edit-stock-product-page";
import AddAndEditBannerImage from "../pages/admin/banner-images/add-and-edit/add-and-edit-banner-image";
import BannerImages from "../pages/admin/banner-images/banner-images";
import ChangePassword from "../pages/admin/change-password/change-password";
import CustomerCartList from "../pages/admin/customer-cart-list/customer-cart-list";
import AddAndEditCustomer from "../pages/admin/customers/add-and-edit/add-and-edit-customer";
import Customers from "../pages/admin/customers/customers";
import Dashboard from "../pages/admin/dashboard/dashboard";
import Orders from "../pages/admin/orders/orders";
import PersonalizedUsers from "../pages/admin/personalized-users/personalized-users";
import AddAndEditSampleCategory from "../pages/admin/sample-categories/add-and-edit/add-and-edit-sample-category";
import SampleCategories from "../pages/admin/sample-categories/sample-categories";
import AdminSampleProducts from "../pages/admin/sample-products/sample-products";
import AddAndEditStockCategory from "../pages/admin/stock-categories/add-and-edit/add-and-edit-stock-category";
import StockCategories from "../pages/admin/stock-categories/stock-categories";
import StockProducts from "../pages/admin/stock-products/stock-products";
import UserLog from "../pages/admin/user-log/user-log";
import AddAndEditUser from "../pages/admin/users/add-and-edit/add-and-edit-user";
import Users from "../pages/admin/users/users";
import Login from "../pages/authentication/login";
import Register from "../pages/authentication/register";
import VerifyOtp from "../pages/authentication/verify-otp";
import Cart from "../pages/cart/cart";
import Home from "../pages/home/home";
import OrderDetails from "../pages/order-details/order-details";
import Order from "../pages/order/order";
import ProductDetails from "../pages/product-details/product-details";
import Products from "../pages/products/products";
import SampleProducts from "../pages/sample-products/sample-products";

const routes = [
  {
    path: "/login",
    element: <Login />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/verify-otp",
    element: <VerifyOtp />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/register",
    element: <Register />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/",
    element: <Home />,
    isPrivate: true,
    layoutType: "Blank",
  },

  {
    path: "/products",
    element: <Products />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "/sample-products",
    element: <SampleProducts />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "/cart",
    element: <Cart />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "/order",
    element: <Order />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "/order/:id",
    element: <OrderDetails />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "/product/:id",
    element: <ProductDetails />,
    isPrivate: true,
    layoutType: "Blank",
  },

  //Admin

  {
    path: "admin/dashboard",
    element: <Dashboard />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/change-password",
    element: <ChangePassword />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/users",
    element: <Users />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/users/add",
    element: <AddAndEditUser />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/users/edit/:id",
    element: <AddAndEditUser isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/user-log",
    element: <UserLog />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/customers",
    element: <Customers />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/customers/add",
    element: <AddAndEditCustomer />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/customers/edit/:id",
    element: <AddAndEditCustomer isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-categories",
    element: <SampleCategories />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-categories/add",
    element: <AddAndEditSampleCategory />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-categories/edit/:id",
    element: <AddAndEditSampleCategory isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-categories",
    element: <StockCategories />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-categories/add",
    element: <AddAndEditStockCategory />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-categories/edit/:id",
    element: <AddAndEditStockCategory isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-products",
    element: <AdminSampleProducts />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-products/add",
    element: <AddAndEditSampleProductPage />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/sample-products/edit/:id",
    element: <AddAndEditSampleProductPage isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-products",
    element: <StockProducts />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-products/add",
    element: <AddAndEditStockProductPage />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/stock-products/edit/:id",
    element: <AddAndEditStockProductPage isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/banner-images",
    element: <BannerImages />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/banner-images/add",
    element: <AddAndEditBannerImage />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/banner-images/edit/:id",
    element: <AddAndEditBannerImage isEdit={true} />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/orders",
    element: <Orders />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/orders/:id",
    element: <OrderDetails />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/personalized-users",
    element: <PersonalizedUsers />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/personalized-users/:user/products",
    element: <PersonalizedSampleProductsPage />,
    isPrivate: true,
    layoutType: "Blank",
  },
  {
    path: "admin/customer-cart-list",
    element: <CustomerCartList />,
    isPrivate: true,
    layoutType: "Blank",
  },
];

export default routes;
